var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as PromoCodeFactory from "../../classes/definitions/promoCode/promoCode";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import PromoCodesList from '../../components/PromoCodes/PromoCodesList/PromoCodesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./PromoCodesReduxProps";
var PromoCodes = /** @class */ (function (_super) {
    __extends(PromoCodes, _super);
    function PromoCodes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null,
            selectedFile: '',
            buttonDisabled: false,
            refresh_message: null,
        };
        _this.onChangeHandler = function (event) {
            _this.setState({
                selectedFile: event.target.files[0]
            });
        };
        _this.submitForm = function () {
            var formData = new FormData();
            // Update the formData object
            formData.append("file", _this.state.selectedFile, 'file.csv');
            _this.api.postPromocodeFile(formData)
                .then(function (response) {
                _this.setState({
                    buttonDisabled: true,
                    refresh_message: response.data.message
                });
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message + ' ' + err.response.data.errors[0],
                });
            });
        };
        _this.refreshButtonStatus = function () {
            _this.api.getRefreshButtonStatus()
                .then(function (response) {
                if (response.data.status === 'in_progress') {
                    _this.setState({ buttonDisabled: true });
                }
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message,
                });
            });
        };
        _this.getAllPromoCodes = function (pageNum) {
            _this.api.getPromoCodes(pageNum)
                .then(function (response) {
                var codes = PromoCodeFactory.createPromoCodes(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: codes, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим методите за доставка.', _this.props.history);
            });
        };
        _this.search = function (event) {
            clearTimeout(_this.state.delaySearchTimer);
            var searchVal = event.target.value;
            if (searchVal) {
                _this.setState({
                    delaySearchTimer: setTimeout(function () {
                        _this.api
                            .searchPromoCodes(searchVal)
                            .then(function (response) {
                            var orders = PromoCodeFactory.createPromoCodes(response.data);
                            _this.setState({ data: orders });
                        })
                            .catch(function (error) {
                            _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с промо кода', _this.props.history);
                        });
                    }, 1000),
                });
                return;
            }
            _this.getAllPromoCodes(1);
        };
        _this.toNewPromoCode = function () {
            _this.props.history.push(AppRoutes.promoCode.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    PromoCodes.prototype.componentDidMount = function () {
        this.getAllPromoCodes(1);
        this.refreshButtonStatus();
    };
    PromoCodes.prototype.componentWillUnmount = function () {
        // TODO
    };
    PromoCodes.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u0440\u043E\u043C\u043E \u041A\u043E\u0434"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("h4", null, "\u041A\u0430\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u043E\u0432\u0435 \u0447\u0440\u0435\u0437 \u0444\u0430\u0439\u043B."),
                        React.createElement("div", { className: "" },
                            React.createElement("input", { type: "file", name: "file", onChange: this.onChangeHandler }),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("button", { type: "button", disabled: this.state.buttonDisabled, className: "btn btn-sm btn-primary", onClick: this.submitForm },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0417\u0430\u043F\u043E\u0447\u043D\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0430\u043D\u0435")),
                        React.createElement("div", null,
                            React.createElement("p", null, this.state.refresh_message)))),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewPromoCode, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u043F\u0440\u043E\u043C\u043E \u043A\u043E\u0434")),
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(PromoCodesList, { gridData: data, meta: meta, getAllPromoCodes: this.getAllPromoCodes, search: this.search, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return PromoCodes;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(PromoCodes);



//////////////////
// WEBPACK FOOTER
// ./src/views/PromoCodes/PromoCodes.tsx
// module id = 413
// module chunks = 0